import { Alert, AlertLevel } from '@cluey/cluey-components';
import classNames from 'classnames';

export type VoucherInfoProps = {
  alertType?: AlertLevel;
  title?: string;
  body?: React.ReactNode;
  color?: string;
};

const VoucherInfo = ({ alertType = 'info', title, body, color = '' }: VoucherInfoProps) => {
  return (
    <div className={classNames('mt-7 flex flex-col gap-x-3.5 rounded-lg lg:flex-row', color)} role="alert">
      <Alert
        body={null}
        className={classNames('mb-0 grow items-start')}
        title={title || 'Cluey Voucher issued for holiday cancellation'}
        type={alertType}
      >
        {body}
      </Alert>
    </div>
  );
};

export default VoucherInfo;
